let cachedUserIdentities: Set<string> = new Set<string>();

export function setCachedCoprincipalUserIdentities(userIdentities: Set<string>) {
    cachedUserIdentities = userIdentities;
}

export default function coprincipalUserIdentities(): Set<string> {
    return cachedUserIdentities;
}
